export const productListConst = [
	{
		id: "DUJ3287DNS8SF",
		prdt_img: "/asset/products/grey-top.png",
		prdt_imgXs: "/asset/products/grey-top-xs.png",
		prdt_imgXl: "/asset/products/grey-top-xl.png",
		prdt_title: "Apollo",
		prdt_subTitle: "Running Short",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#D3D2D5",
		prdt_color_arr: ["#D3D2D5", "#2B2B2B", "#0F6450"],
		prdt_size: "XS",
		prdt_size_arr: ["XS", "S", "M", "L"],
		prdt_price: 50,
		prdt_instock: true,
		// prdt_qty: 1,
	},
	{
		id: "JOIGUFI3493FDF",
		prdt_img: "/asset/products/peach-sleeve.png",
		prdt_imgXs: "/asset/products/peach-sleeve.png",
		prdt_imgXl: "/asset/products/peach-sleeve.png",
		prdt_title: "Apollo",
		prdt_subTitle: "Running Short",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#D3D2D5",
		prdt_color_arr: ["#D3D2D5", "#2B2B2B", "#0F6450"],
		prdt_size: "XS",
		prdt_size_arr: ["XS", "S", "M", "L"],
		prdt_price: 50,
		prdt_instock: true,
		// prdt_qty: 1,
	},
	{
		id: "BUYW3487GUDSDSF",
		prdt_img: "/asset/products/stripe-sleeve.png",
		prdt_imgXs: "/asset/products/stripe-sleeve.png",
		prdt_imgXl: "/asset/products/stripe-sleeve.png",
		prdt_title: "Apollo",
		prdt_subTitle: "Running Short",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#D3D2D5",
		prdt_color_arr: ["#D3D2D5", "#2B2B2B", "#0F6450"],
		prdt_size: "XS",
		prdt_size_arr: ["XS", "S", "M", "L"],
		prdt_price: 50,
		prdt_instock: false,
	},
	{
		id: "634VUSD78E3SDSF",
		prdt_img: "/asset/products/creme-bag.png",
		prdt_imgXs: "/asset/products/creme-bag.png",
		prdt_imgXl: "/asset/products/creme-bag.png",
		prdt_title: "Apollo",
		prdt_subTitle: "Running Short",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#D3D2D5",
		prdt_color_arr: ["#D3D2D5", "#2B2B2B", "#0F6450"],
		prdt_size: "XS",
		prdt_size_arr: ["XS", "S", "M", "L"],
		prdt_price: 50,
		prdt_instock: true,
		// prdt_qty: 1,
	},
	{
		id: "98SRDFGVSKUEWERK",
		prdt_img: "/asset/products/grey-top.png",
		prdt_imgXs: "/asset/products/grey-top-xs.png",
		prdt_imgXl: "/asset/products/grey-top-xl.png",
		prdt_title: "Apollo",
		prdt_subTitle: "Running Short",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#D3D2D5",
		prdt_color_arr: ["#D3D2D5", "#2B2B2B", "#0F6450"],
		prdt_size: "XS",
		prdt_size_arr: ["XS", "S", "M", "L"],
		prdt_price: 50,
		prdt_instock: true,
		// prdt_qty: 1,
	},
	{
		id: "RE4342JHSD989DSQW",
		prdt_img: "/asset/products/stripe-sleeve.png",
		prdt_imgXs: "/asset/products/stripe-sleeve.png",
		prdt_imgXl: "/asset/products/stripe-sleeve.png",
		prdt_title: "Apollo",
		prdt_subTitle: "Running Short",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#D3D2D5",
		prdt_color_arr: ["#D3D2D5", "#2B2B2B", "#0F6450"],
		prdt_size: "XS",
		prdt_size_arr: ["XS", "S", "M", "L"],
		prdt_price: 50,
		prdt_instock: true,
		// prdt_qty: 1,
	},
	{
		id: "RE434873DOHF9DSQW",
		prdt_img: "/asset/products/jupiter.png",
		prdt_imgXs: "/asset/products/jupiter.png",
		prdt_imgXl: "/asset/products/jupiter.png",
		prdt_title: "Jupiter",
		prdt_subTitle: "Wayfarer",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#1D1F22",
		prdt_color_arr: ["#1D1F22", "#15A4C3", "#EA8120"],
		prdt_size: "M",
		prdt_size_arr: ["S", "M"],
		prdt_price: 75,
		prdt_instock: true,
		// prdt_qty: 1,
	},
];

export const defaultCartItem = [
	{
		id: "DUJ3287DNS8SF",
		prdt_img: "/asset/products/grey-top.png",
		prdt_imgXs: "/asset/products/grey-top-xs.png",
		prdt_imgXl: "/asset/products/grey-top-xl.png",
		prdt_title: "Apollo",
		prdt_subTitle: "Running Short",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#D3D2D5",
		prdt_size: "L",
		prdt_price: 50,
		prdt_instock: true,
		prdt_qty: 1,
	},
	{
		id: "JOIGUFI3493FDF",
		prdt_img: "/asset/products/peach-sleeve.png",
		prdt_imgXs: "/asset/products/grey-top-xs.png",
		prdt_imgXl: "/asset/products/grey-top-xl.png",
		prdt_title: "Apollo",
		prdt_subTitle: "Running Short",
		prdt_desc:
			"Find stunning women's cocktail dresses and party dresses. Stand out in lace and metallic cocktail dresses and party dresses from all your favorite brands.",
		prdt_color: "#0F6450",
		prdt_size: "S",
		prdt_price: 50,
		prdt_qty: 1,
	},
];
